import { timeOptions } from 'constants';
import { create } from 'zustand';
export const useTrainingStore = create((set, get) => ({
  selectedDateFilterTraining: timeOptions.find((opt) => opt.value === 2),
  setSelectedDateFilterTraining: (selectedDateFilterTraining = {}) =>
    set(() => ({ selectedDateFilterTraining })),
}));
